import React, { useState, useEffect, useRef } from "react";
import "./Photos.css";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Photos = () => {
  const [activeTab, setActiveTab] = useState("photo");

  const itemsRef = useRef([]);
  itemsRef.current = [];

  const addToRefs = (el) => {
    if (el && !itemsRef.current.includes(el)) {
      itemsRef.current.push(el);
    }
  };

  useEffect(() => {
    Fancybox.bind("[data-fancybox='gallery']", {
      Thumbs: false,
      Toolbar: {
        display: ["zoom", "close"],
      },
    });

    return () => Fancybox.destroy();
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(
      ".gallery-image-container"
    );

    elements.forEach((el, index) => {
      setTimeout(() => {
        if (
          el.classList.contains("gallery-left") ||
          el.classList.contains("gallery-left2") ||
          el.classList.contains("video-left")
        ) {
          el.classList.add("animate-left");
        }

        else if (
          el.classList.contains("gallery-right") ||
          el.classList.contains("gallery-right2") ||
          el.classList.contains("video-right")
        ) {
          el.classList.add("animate-right");
        }

        else {
          el.classList.add("animate-scale");
        }
      }, index * 150);
    });

  }, [activeTab]);
  return (
    <>
      {/* Banner */}
      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/gallery.png"
          alt=""
          className="inner-banner-img"
        />
        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Gallery</div>
        </div>
      </div>

      <div className="overview-container">
        <section className="gallery-section">
          <div>

            {/* Tabs */}
            <div className="gallery-tab">
              <button
                className={`gallery-tablink ${activeTab === "photo" ? "gallery-active" : ""
                  }`}
                onClick={() => setActiveTab("photo")}
              >
                Photo
              </button>

              <button
                className={`gallery-tablink ${activeTab === "video" ? "gallery-active" : ""
                  }`}
                onClick={() => setActiveTab("video")}
              >
                Video
              </button>
            </div>

            <div className="gallery-content-wrapper">

              {/* PHOTO */}
              {activeTab === "photo" && (
                <div className="gallery-tabcontent">
                  <div className="gallery-wrapper">

                    <div ref={addToRefs} className="gallery-image-container gallery-left">
                      <a href="/images/gallery/photo_6.png" data-fancybox="gallery">
                        <img src="/images/gallery/photo_6.png" alt="" />
                      </a>
                      <div className="gallery-image-text">Sportify 2024: Man City Football School Launch</div>
                    </div>

                    <div ref={addToRefs} className="gallery-image-container gallery-middle">
                      <a href="/images/gallery/photo_5.png" data-fancybox="gallery">
                        <img src="/images/gallery/photo_5.png" alt="" />
                      </a>
                      <div className="gallery-image-text">Celebrating 10 Years of Uttarbanga Medha Ratna Utsav</div>
                    </div>

                    <div ref={addToRefs} className="gallery-image-container gallery-right">
                      <a href="/images/gallery/photo_4.png" data-fancybox="gallery">
                        <img src="/images/gallery/photo_4.png" alt="" />
                      </a>
                      <div className="gallery-image-text">WACE Launch at TIG Siliguri</div>
                    </div>

                    <div ref={addToRefs} className="gallery-image-container gallery-left2">
                      <a href="/images/gallery/photo_3.png" data-fancybox="gallery">
                        <img src="/images/gallery/photo_3.png" alt="" />
                      </a>
                      <div className="gallery-image-text">Geetanjali Indian by Aajkal</div>
                    </div>

                    <div ref={addToRefs} className="gallery-image-container gallery-middle2">
                      <a href="/images/gallery/photo_2.png" data-fancybox="gallery">
                        <img src="/images/gallery/photo_2.png" alt="" />
                      </a>
                      <div className="gallery-image-text">Silver Jubilee Closing Ceremony: 25 Years of Excellence</div>
                    </div>

                    <div ref={addToRefs} className="gallery-image-container gallery-right2">
                      <a href="/images/gallery/photo_1.png" data-fancybox="gallery">
                        <img src="/images/gallery/photo_1.png" alt="" />
                      </a>
                      <div className="gallery-image-text">Sportify 2024: Man City Football School Launch</div>
                    </div>

                  </div>
                </div>
              )}

              {/* VIDEO */}
              {activeTab === "video" && (
                <div className="gallery-tabcontent">
                  <div className="gallery-wrapper">

                    <div ref={addToRefs} className="gallery-image-container video-left">
                      <a href="#">
                        <img src="/images/gallery/video/thum.jpg" alt="" />
                        <span className="gallery-item-text">Video Title or Description</span>
                      </a>
                    </div>

                    <div ref={addToRefs} className="gallery-image-container video-middle">
                      <a href="#">
                        <img src="/images/gallery/video/thum.jpg" alt="" />
                        <span className="gallery-item-text">Video Title or Description</span>
                      </a>
                    </div>

                    <div ref={addToRefs} className="gallery-image-container video-right">
                      <a href="#">
                        <img src="/images/gallery/video/thum.jpg" alt="" />
                        <span className="gallery-item-text">Video Title or Description</span>
                      </a>
                    </div>

                  </div>
                </div>
              )}

            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Photos;